import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { InlineSelect, MenuItem, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useStoreActions } from '~/contexts';
import { serviceBillingModel, serviceModel } from '~/models';
import { validateBillingDayOfMonth } from '~/models/service';
export const GetInlineUpfrontSelectTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            InlineUpfrontSelectTestIds: {
                Root: "".concat(parentTestId, "is-billed-upfront-dropdown"),
                Option: (value)=>value === 'true' ? "".concat(parentTestId, "is-billed-upfront-option-1") : "".concat(parentTestId, "is-billed-upfront-option-0")
            }
        }
    });
function getUpfrontLabel(isBilledUpfront, isQuarterly) {
    if (isQuarterly) {
        return isBilledUpfront ? 'upfront on the 1st day of every quarter' : 'on the last day of every quarter';
    }
    return isBilledUpfront ? 'upfront' : 'at the end of the billing cycle';
}
export function InlineUpfrontSelect(param) {
    let { service, testId, disabled, isReadOnly, isActiveAgreement, skin, variant, weight, onChange, onHasError, onBillingDayOfMonthError } = param;
    var _options_find;
    const { logBI } = useStoreActions();
    const { InlineUpfrontSelectTestIds } = useMemo(()=>GetInlineUpfrontSelectTID(testId), [
        testId
    ]);
    const isBilledUpfront = serviceBillingModel.isBilledUpfront(service.billing);
    const isQuarterly = serviceBillingModel.isQuarterly(service.billing);
    const options = useMemo(()=>[
            {
                key: 'start',
                value: 'true',
                text: getUpfrontLabel(true, isQuarterly)
            },
            {
                key: 'end',
                value: 'false',
                text: getUpfrontLabel(false, isQuarterly)
            }
        ], [
        isQuarterly
    ]);
    const currentValue = isBilledUpfront ? 'true' : 'false';
    const readOnlyValue = ((_options_find = options.find((opt)=>opt.value === currentValue)) === null || _options_find === void 0 ? void 0 : _options_find.text) || '';
    if (isReadOnly) {
        return /*#__PURE__*/ _jsx(Typography, {
            testId: InlineUpfrontSelectTestIds.ViewOnlyText(),
            skin: skin,
            variant: variant,
            weight: weight,
            children: readOnlyValue
        });
    }
    return /*#__PURE__*/ _jsx(InlineSelect, {
        bi: {
            name: 'inline_upfront_select'
        },
        skin: "primary",
        value: currentValue,
        testId: InlineUpfrontSelectTestIds.Root(),
        disabled: disabled,
        onChange: (e)=>{
            const newIsBilledUpfront = e.target.value === 'true';
            if (isActiveAgreement !== undefined) {
                logBI(11016, {
                    isActiveAgreement,
                    serviceId: service.id,
                    isBilledUpfront: newIsBilledUpfront
                });
            }
            const billingDayOfMonth = serviceModel.billingDayOfMonth(service);
            if (billingDayOfMonth != null) {
                const hasError = validateBillingDayOfMonth(billingDayOfMonth, newIsBilledUpfront);
                onBillingDayOfMonthError === null || onBillingDayOfMonthError === void 0 ? void 0 : onBillingDayOfMonthError(hasError);
                onHasError === null || onHasError === void 0 ? void 0 : onHasError(service.id, hasError);
            }
            onChange(service.id, newIsBilledUpfront);
        },
        SelectProps: {
            renderValue: (value)=>getUpfrontLabel(value === 'true', isQuarterly)
        },
        children: options.map((param)=>{
            let { key, value, text } = param;
            return /*#__PURE__*/ _jsx(MenuItem, {
                value: value,
                testId: InlineUpfrontSelectTestIds.Option(value),
                children: text
            }, key);
        })
    });
}
